import { useScrollDirection } from "./use-scroll-direction";

export { Axis, Direction } from "./types";

export default useScrollDirection;
